import React, { useState, useEffect } from "react";
import axios from "axios";
import { withRouter, Link, useHistory } from "react-router-dom";
import {
  Card,
  CardBody,
  Col,
  Row,
  Modal,
  Button,
  ModalHeader,
  ModalBody,
  Label,
  Container,
  Input,
  Alert,
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  InputGroup,
  InputGroupAddon,
} from "reactstrap";
import { FaPlus, FaEdit } from "react-icons/fa";
import Select from "react-select";
// import CouponForm from "../CouponFrom";
// import CouponFormComponent from "../";
// import "../Coupons/index.css";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import moment from "moment";
import * as XLSX from "xlsx";
// import { utils, write, writeFileSync } from "xlsx";
import paginationFactory, {
  PaginationProvider,
  PaginationListStandalone,
} from "react-bootstrap-table2-paginator";
import BootstrapTable from "react-bootstrap-table-next";
import { BASE_URL } from "../../config";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@mui/material";
import { DateTimePicker, MobileDateTimePicker } from "@mui/x-date-pickers";
import { get } from "lodash";
// const columns = [
//   {
//     dataField: "id",
//     text: "ID",
//     sort: true,
//   },
//   {
//     dataField: "name",
//     text: "Name",
//     sort: true,
//   },
//   {
//     dataField: "email",
//     text: "Email",
//     sort: true,
//   },
//   // add more columns as needed
// ];
export const MORE_FEATURE_OPTIONS = [
  { value: "school_tag", label: "School Tag" },
  { value: "blood_bank_tag", label: "Blood Bank Tag" },
];

export const getMoreFeatureFlagPayload = (selectedValues) => {
  const values = Array.isArray(selectedValues)
    ? selectedValues
    : selectedValues
    ? [selectedValues]
    : [];

  return {
    school_tag: values.includes("school_tag"),
    blood_bank_tag: values.includes("blood_bank_tag"),
  };
};

const INSURANCE_PRODUCT_CATEGORIES = ["QR Bag", "Dolphin Bag"];

const isInsuranceProductCategory = (category) =>
  INSURANCE_PRODUCT_CATEGORIES.includes(category);

const REQUIRED_FIELD_MESSAGE = "This field is required.";
const GENERATE_TAG_ERROR_TOAST_ID = "generate-tag-number-error";

const getGenerateTagNumberErrorMessage = (data) => {
  if (typeof data === "string" && data) {
    return data;
  }
  if (data && data.message) {
    return data.message;
  }
  return "Unable to generate tags. Please try again.";
};

const isBlankFormValue = (value) =>
  value === null ||
  value === undefined ||
  (typeof value === "number" && Number.isNaN(value)) ||
  String(value).trim() === "";

function TagGeneration() {
    // Insurance Modal State
    const [insuranceModalOpen, setInsuranceModalOpen] = useState(false);
    const [insuranceStatus, setInsuranceStatus] = useState([]);
    const [insuranceValue, setInsuranceValue] = useState("3000");
    const [insuranceValueError, setInsuranceValueError] = useState("");
    const [insuranceStatusError, setInsuranceStatusError] = useState("");
    const INSURANCE_VALUE_OPTIONS = ["3000", "5000", "10000"];

    // Modal handlers
    const openInsuranceModal = () => setInsuranceModalOpen(true);
    const closeInsuranceModal = () => {
      setInsuranceModalOpen(false);
      setInsuranceStatus("");
      setInsuranceValue("3000");
      setInsuranceValueError("");
    };
    const handleInsuranceStatusChange = (status) => {
      setInsuranceStatus((prev) => {
        if (prev.includes(status)) {
          return prev.filter((s) => s !== status);
        } else {
          return [...prev, status];
        }
      });
    };

    const handleInsuranceSubmit = async (e) => {
      e.preventDefault();
      let hasError = false;
      setInsuranceValueError("");
      setInsuranceStatusError("");

      // 1. Required / allowed-value validation
      if (insuranceValue === "" || insuranceValue === null) {
        setInsuranceValueError("Insurance amount is required.");
        toast.error("Insurance amount is required.", { autoClose: 6000 });
        hasError = true;
      } else if (!INSURANCE_VALUE_OPTIONS.includes(String(insuranceValue))) {
        setInsuranceValueError("Insurance amount must be 3000, 5000, or 10000.");
        toast.error("Insurance amount must be 3000, 5000, or 10000.", { autoClose: 6000 });
        hasError = true;
      }

      // 5. Empty Tag Status Validation
      if (!insuranceStatus || insuranceStatus.length === 0) {
        setInsuranceStatusError("Please select at least one tag status.");
        toast.error("Please select at least one tag status.", { autoClose: 6000 });
        hasError = true;
      }

      if (!editingTag) {
        toast.error("No tag selected for insurance update.", { autoClose: 6000 });
        return;
      }

      if (hasError) {
        return;
      }

      setLoading(true);
      try {
        const payload = {
          tag_initial: editingTag.tag_initial,
          product_category: editingTag.product_category,
          tag_status: insuranceStatus,
          insurance_value: insuranceValue,
        };
        const response = await axios.post(
          `${BASE_URL}/api/updateInsurance`,
          payload,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        toast.success(
          response.data?.message || "Insurance updated successfully",
          {
            autoClose: 6000,
          }
        );
        closeInsuranceModal();
        setTimeout(() => {
          window.location.reload();
        }, 1000);
        fetchData();
      } catch (error) {
        toast.error(
          error.response?.data?.message || "Error updating insurance",
          {
            autoClose: 6000,
          }
        );
      } finally {
        setLoading(false);
      }
    };
  const authUser = JSON.parse(localStorage.getItem("authUser"));
  const token = authUser ? authUser.token : null;
  const [tagInitial, setTagInitial] = useState("");
  const [productCategory, setProductCategory] = useState("");
  const [productCategories, setProductCategories] = useState([]);
  const [count, setCount] = useState(0);
  const [valuableType, setValuableType] = useState("");
  const [numOfDigits, setNumOfDigits] = useState(4);
  const [isNumOfDigitsDisabled, setIsNumOfDigitsDisabled] = useState(false);
  const [tableData, setTableData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [tagnumber, setTagNumber] = useState([]);
  const [companyName, setCompanyName] = useState("");
  const [searchKey, setSearchKey] = useState("");
  const [modalOpen, setModalOpenState] = useState(false);
  const [newModalOpen, setNewModalOpen] = useState(false);
  const [error, setError] = useState("");
  const [formErrors, setFormErrors] = useState({});
  const [numError, setNumError] = useState("");
  const [possiblity, setPossibility] = useState("");
  const [updatepossiblity, setupdatePossibility] = useState("");
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [companies, setCompanies] = useState([]);
  const [numOfDigitsMap, setNumOfDigitsMap] = useState("");
  const [tagGeneration, setTagGeneration] = useState("");
  const [timerComplete, setTimerComplete] = useState(false);
  const [options, setOptions] = useState({
    user: false,
    tag8Support: false,
  });
  const [preJuly2024TagInitials, setPreJuly2024TagInitials] = useState([]);
  const [validityNumber, setValidityNumber] = useState("");
  const [validityUnit, setValidityUnit] = useState("");
  // Insurance flag: null = not selected, true = Yes, false = No
  const [insuranceFlag, setInsuranceFlag] = useState(null);
  // New: Insurance Amount state for main form
  const [insuranceAmount, setInsuranceAmount] = useState("3000");
  const [validityToDate, setValidityToDate] = useState("");
  const [existingTagInitials, setExistingTagInitials] = useState([]);
  const [errorMessageinital, setErrorMessageinital] = useState("");
  const [isSchoolTag, setIsSchoolTag] = useState(false);
  const [schoolTagOption, setSchoolTagOption] = useState([]);
  const [loading, setLoading] = useState(false);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  // const [snackbarTimer, setSnackbarTimer] = useState(null);
  const [snackbarSeverity, setSnackbarSeverity] = useState("success");
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [editingTag, setEditingTag] = useState(null);
  const loaderContainerStyle = {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    background: "rgba(0, 0, 0, 0.5)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    zIndex: 9999,
  };

  const loaderStyle = {
    width: "100px",
    height: "100px",
  };
  const handleNewTagGeneration = async () => {
    try {
      setLoading(true); // Show loader
      // console.log(count, numOfDigits, typeof count, "counttt");
      const response = await axios.post(`${BASE_URL}/api/genratetags`, {
        count: parseInt(count, 10),
        numOfDigits,
      },{
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
          );

      if (response.status === 200) {
        // Handle successful response
        // console.log("Tags generated successfully");
        toast.success(response.data.message, {
          autoClose: 6000,
        });
        setCount(0);
        // setNumOfDigits("");
      }
    } catch (error) {
      // Handle error response
      console.error("Failed to generate tags", error);
      // console.log(error.response.data.message, "response");
      toast.error(error.response.data, {
        autoClose: 6000,
      });
    } finally {
      setLoading(false); // Hide loader
    }

    setNewModalOpen(false);
  };
  const handleCountChange = (e) => {
    const newValue = e.target.value;
  
    // Allow input update first
    setCount(newValue);
  
    // Convert string input to a number for comparison
    const numericValue = Number(newValue);
  
    // console.log(numericValue, typeof numericValue, "numericValue");
  
    // Check if editingTag is not null and count exceeds 25000
    if (editingTag !== null && numericValue > 25000) {
      setError("Count cannot exceed 25000");
    } else {
      setError(""); // Clear error if within limit
    }
    setFormErrors((prev) => {
      if (!prev.count) {
        return prev;
      }
      const next = { ...prev };
      delete next.count;
      return next;
    });
  };
  
  
  // const openEndDateDialog = couponInfo => {
  //   if (couponInfo) {
  //     // console.log("coupon infor new",couponInfo);
  //     const endDate = moment(new Date(couponInfo.end_date));
  //     setDtpEndDate(endDate);
  //     // console.log("Seto",dtpEndDate);
  //     // console.log("Setdb",endDate);
  //     setSelectedCouponInfo(couponInfo);
  //     setIsEndDateDialogOpen(true);
  //   } else {
  //     toast.warn("Something went wrong!!! Please try after sometimes.");
  //   }
  // };
  useEffect(() => {
    // console.log(tagnumber, "tagggggsgsgsg");
    const delay = 3000;
    const timer = setTimeout(() => {
      setTimerComplete(true);
    }, delay);

    // Clear the timeout if the component unmounts or the dependency changes
    return () => clearTimeout(timer);
  }, [tagnumber]);
  const updateTag = (updatedTag) => {
    // console.log(tags, "settag");
    const index = tags.findIndex((tag) => tag.id === updatedTag.id);

    if (index !== -1) {
      const updatedTags = [...tags];
      updatedTags[index] = updatedTag;
      setTags(updatedTags);
    }
  };
  const clearFormErrors = (...fields) => {
    setFormErrors((prev) => {
      const next = { ...prev };
      let changed = false;
      fields.forEach((field) => {
        if (next[field]) {
          delete next[field];
          changed = true;
        }
      });
      return changed ? next : prev;
    });
  };

  const getTagGenerationFormErrors = () => {
    const errors = {};

    if (isBlankFormValue(tagInitial)) {
      errors.tagInitial = REQUIRED_FIELD_MESSAGE;
    } else if (errorMessageinital) {
      errors.tagInitial = errorMessageinital;
    }

    if (isBlankFormValue(productCategory)) {
      errors.productCategory = REQUIRED_FIELD_MESSAGE;
    }

    if (isBlankFormValue(numOfDigits)) {
      errors.numOfDigits = REQUIRED_FIELD_MESSAGE;
    } else if (numError) {
      errors.numOfDigits = numError;
    }

    if (!editingTag) {
      if (isBlankFormValue(valuableType)) {
        errors.valuableType = REQUIRED_FIELD_MESSAGE;
      }

      if (isBlankFormValue(companyName)) {
        errors.companyName = REQUIRED_FIELD_MESSAGE;
      }

      if (
        productCategory === "QR Human" &&
        (!Array.isArray(schoolTagOption) || schoolTagOption.length === 0)
      ) {
        errors.schoolTagOption = REQUIRED_FIELD_MESSAGE;
      }

      if (!options.user && !options.tag8Support) {
        errors.finderOptions = REQUIRED_FIELD_MESSAGE;
      }

      if (isBlankFormValue(validityNumber)) {
        errors.validityNumber = REQUIRED_FIELD_MESSAGE;
      } else if (Number(validityNumber) < 0) {
        errors.validityNumber = "Validity Number cannot be negative.";
      }

      if (isBlankFormValue(validityUnit)) {
        errors.validityUnit = REQUIRED_FIELD_MESSAGE;
      }
    }

    if (isBlankFormValue(count)) {
      errors.count = REQUIRED_FIELD_MESSAGE;
    } else if (Number.isNaN(Number(count))) {
      errors.count = "Please enter a valid number.";
    } else if (editingTag && Number(count) > 25000) {
      errors.count = "Count cannot exceed 25000";
    }

    if (isInsuranceProductCategory(productCategory)) {
      if (insuranceFlag === null) {
        errors.insuranceFlag = REQUIRED_FIELD_MESSAGE;
      } else if (
        insuranceFlag === true &&
        !["3000", "5000", "10000"].includes(String(insuranceAmount))
      ) {
        errors.insuranceAmount = REQUIRED_FIELD_MESSAGE;
      }
    }

    if (isBlankFormValue(validityToDate)) {
      errors.validityToDate = REQUIRED_FIELD_MESSAGE;
    }

    return errors;
  };

  const normalizeSchoolTagValue = (value) => {
    if (typeof value === "boolean") {
      return value;
    }

    if (typeof value === "number") {
      return value === 1;
    }

    if (typeof value === "string") {
      const normalizedValue = value.trim().toLowerCase();
      if (["true", "1", "yes", "y"].includes(normalizedValue)) {
        return true;
      }

      if (["false", "0", "no", "n", "", "null", "undefined"].includes(normalizedValue)) {
        return false;
      }
    }

    return Boolean(value);
  };

  const getSelectedMoreFeatureValues = (source = {}) => {
    const selectedValues = [];

    const addSelectedValue = (optionValue) => {
      if (
        MORE_FEATURE_OPTIONS.some((option) => option.value === optionValue) &&
        !selectedValues.includes(optionValue)
      ) {
        selectedValues.push(optionValue);
      }
    };

    if (
      normalizeSchoolTagValue(source.school_tag) ||
      normalizeSchoolTagValue(source.isSchoolTag) ||
      normalizeSchoolTagValue(source.is_school_tag)
    ) {
      addSelectedValue("school_tag");
    }

    if (normalizeSchoolTagValue(source.blood_bank_tag)) {
      addSelectedValue("blood_bank_tag");
    }

    const listSources = [source.more_features, source.moreFeatures, source.more_feature];
    listSources.forEach((list) => {
      const values = Array.isArray(list)
        ? list
        : typeof list === "string" && list.length
        ? list.split(",").map((item) => item.trim()).filter(Boolean)
        : [];
      values.forEach((value) => addSelectedValue(value));
    });

    return selectedValues;
  };

  const updateSchoolTagSelection = (selected) => {
    const selectedValues = Array.isArray(selected)
      ? selected.map((option) => option?.value).filter(Boolean)
      : [];
    setSchoolTagOption(selectedValues);
    setIsSchoolTag(selectedValues.includes("school_tag"));
  };

  const handleGenerateTagNumber = async () => {
    const fieldErrors = getTagGenerationFormErrors();
    setFormErrors(fieldErrors);

    if (numError) {
      toast.error(numError, {
        autoClose: 6000,
      });
    }
    if (errorMessageinital) {
      toast.error(errorMessageinital, {
        autoClose: 6000,
      });
    }
    if (Object.keys(fieldErrors).length > 0) {
      return;
    }

    // Insurance amount normalization for QR Bag and Dolphin Bag
    if (isInsuranceProductCategory(productCategory)) {
      if (insuranceFlag === true) {
        const normalizedInsuranceAmount = normalizeInsuranceAmount(insuranceAmount);
        if (!['3000', '5000', '10000'].includes(normalizedInsuranceAmount)) {
          toast.error("Please select a valid insurance amount.", { autoClose: 6000 });
          return;
        }
        setInsuranceAmount(normalizedInsuranceAmount);
      }
      if (insuranceFlag === false) {
        setInsuranceAmount("3000");
      }
    }
    try {
      setLoading(true); // Show loader
      let response;

      if (editingTag) {
        // Prepare payload as per insuranceFlag logic
        const payload = {
          productCategory,
          tag_count: count,
          valuableType,
          companyName,
          numOfDigits,
          tagInitial,
          updatepossibility: editingTag.possibility,
          options,
          validityNumber,
          validityUnit,
          validityToDate,
          insurance_flag: insuranceFlag !== null ? insuranceFlag : editingTag?.insurance_flag,
        };
        if (insuranceFlag === true) {
          payload.insurance_value = normalizeInsuranceAmount(insuranceAmount);
        }
        // If insuranceFlag is false, do not send insurance_value
        let response = await axios.put(
          `${BASE_URL}/api/updateTagNumber/`,
          payload,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        if (response.data.message.includes("Successfully Updated")) {
          toast.success(response.data.message, {
            autoClose: 6000,
          });
          console.log(response,"responseee")
          console.log(response.data.tagGenerationId, "tagGenerationId");
          axios
            .get(`${BASE_URL}/api/fetch-data`, {
              params: {
                tag_generation_id:
                  response.data.tagGenerationId || tagGeneration,
              },
              headers: {
                Authorization: `Bearer ${token}`,
              },
            })
            .then((response) => {
              console.log(response,"dtaa")
              const contentDisposition = response.headers["content-disposition"] || response.headers["Content-Disposition"]; // Ensure headers exist
      let fileName = "tag_data.csv"; // Default filename
      if (contentDisposition) {
        const match = contentDisposition.match(/filename="?([^"]+)"?/);
        if (match && match[1]) {
          fileName = match[1].trim(); // Ensure no extra spaces
        }
      }
      const blob = new Blob([response.data], { type: "text/csv" });
      const link = document.createElement("a");
      link.href = window.URL.createObjectURL(blob);
      link.download = fileName;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
            })
            .catch((error) => {
              console.log("Error fetching data:", error);
            });
          setTimeout(function () {
            window.location.reload();
          }, 20000);
        } else {
          toast.error("No Tags Generated", {
            autoClose: 6000,
          });
        }
        // setTimeout(function () {
        //   window.location.reload();
        // }, 3000);
      } else {
        response = await axios.post(
          `${BASE_URL}/api/generateTagNumber`,
          {
            tagInitial,
            productCategory,
            count,
            numOfDigits,
            valuableType,
            companyName,
            options,
            validityNumber,
            validityUnit,
            validityToDate,
            ...(productCategory === "QR Human"
              ? {
                  ...getMoreFeatureFlagPayload(schoolTagOption),
                  isSchoolTag: schoolTagOption.includes("school_tag"),
                }
              : {}),
            insurance_flag: insuranceFlag === true,
            insurance_value: insuranceFlag ? normalizeInsuranceAmount(insuranceAmount) : undefined,
          },
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
      }
      if (!editingTag) {
        console.log(response.data,"dtatta ")
        if (
          typeof response?.data?.message === "string" &&
          response.data.message.includes("Successfully processed")
        ) {
          toast.success(response.data.message, {
            autoClose: 6000,
          });
          setTimeout(function () {
            window.location.reload();
          }, 3000);
        } else {
          toast.error(getGenerateTagNumberErrorMessage(response?.data), {
            autoClose: 6000,
            toastId: GENERATE_TAG_ERROR_TOAST_ID,
          });
          return;
        }

        const tagNumbers = response.data.tagNumbers;
        setPossibility(response.data.totalCombinations);
        setTagNumber(tagNumbers);
        fetchData();

        const delay = 3000;
        setTimeout(() => {
          setModalOpenState(false);
          setEditingTag(null);
          setTagInitial("");
          setProductCategory("");
          setCount(0);
          setValuableType("");
          setCompanyName("");
          setNumOfDigits(4);
          setPossibility("");
          setValidityNumber(0);
          setValidityUnit("Days");
          setValidityToDate("");
          setSchoolTagOption([]);
          setIsSchoolTag(false);
          setError(""); // Clear error if within limit
          setFormErrors({});
          setInsuranceAmount("3000");
        }, delay);
      } else if (response?.data?.updatedTag) {
        const updatedTag = response.data.updatedTag;
        updateTag(updatedTag);
      }
    } catch (error) {
      console.log(error.response, "errorMessageinital");
      toast.error(getGenerateTagNumberErrorMessage(error.response?.data), {
        autoClose: 6000,
        toastId: GENERATE_TAG_ERROR_TOAST_ID,
      });
    } finally {
      setLoading(false); // Hide loader
    }
  };

  const fetchProductCategories = async () => {
  setLoading(true);
  try {
    // console.log("Manually calling the API");
    const response = await axios.get(`${BASE_URL}/api/getProductCategories`, {
      headers: { Authorization: `Bearer ${token}` },
    });
    // console.log(response.data);
       if (response.data) {
        // Map the response data to only include product categories
        const categories = response.data.map((item) => item.product_category);
        
        // Remove any duplicate categories and set state
        const uniqueCategories = Array.from(new Set(categories));
        // console.log(uniqueCategories,"unie")
        setProductCategories(uniqueCategories);
      }
  } catch (error) {
    console.error("Error fetching product categories:", error);
  }finally {
      setLoading(false); // End loading state
    }
};

  const handleTagInitialChange = (e) => {
    const inputValue = e.target.value.toUpperCase().slice(0, 3);
    setTagInitial(inputValue);

    if (inputValue === "") {
      setErrorMessageinital("");
    } else if (existingTagInitials.includes(inputValue)) {
      setErrorMessageinital("Tag Initial already exists");
    } else {
      setErrorMessageinital("");
    }
    clearFormErrors("tagInitial");
  };
  const toggleModal = () => {
    setModalOpen(!modalOpen);
  };
const handleProductCategory = (e) => {
    const nextCategory = e.target.value;
    setProductCategory(nextCategory);
    setNumOfDigits("");
    setNumError("");
    setSchoolTagOption([]);
    setIsSchoolTag(false);
  };

  const handleEdit = (row) => {
    setEditingTag(row);
    setModalOpenState(true);
    setFormErrors({});

    setTagInitial(row.tag_initial || "");
    setProductCategory(row.product_category || "");
    setCount(row.tag_count || 0);
    setValuableType(row.valuable_type || "");
    setCompanyName(row.company_name || "");
    setTagGeneration(row.tag_generation_id || "");
    const selectedMoreFeatures = getSelectedMoreFeatureValues(row);
    setSchoolTagOption(selectedMoreFeatures);
    setIsSchoolTag(selectedMoreFeatures.includes("school_tag"));
    // console.log(row.Num_of_digits);
    if (row.Num_of_digits) {
      setNumOfDigits(row.Num_of_digits);
      setIsNumOfDigitsDisabled(true);
    } else {
      setNumOfDigits(4);
      setIsNumOfDigitsDisabled(false);
    }
    setOptions({
      user: row.user_support ?? false,
      tag8Support: row.tag8_support ?? false,
    });
    setValidityNumber(row.validity_from_number || 0);
    setValidityUnit(row.validity_from_unit || "");
    const formattedValidityStart = row.validity_start
      ? new Date(row.validity_start).toISOString().split("T")[0]
      : "";
    setValidityToDate(formattedValidityStart);
    setError("");
    // Bind insurance_flag from backend
    setInsuranceFlag(row.insurance_flag === true);
    setInsuranceAmount(normalizeInsuranceAmount(row.insurance_value));
    // setTagNumber(row.tag_number || "");  // Uncomment and adjust if needed
  };

  const toggleDropdown = () => {
    setDropdownOpen(!dropdownOpen);
  };

  const addCompany = () => {
    if (companyName && !companies.includes(companyName)) {
      setCompanies([...companies, companyName]);
      setCompanyName("");
    }
  };
  const handleOptionChange = (option) => {
    setOptions((prevOptions) => ({
      ...prevOptions,
      [option]: !prevOptions[option],
    }));
  };
  const selectCompany = (selectedCompany) => {
    setCompanyName(selectedCompany);
    setDropdownOpen(false);
    clearFormErrors("companyName");
  };
  // const handleDelete = async (product_category, tag_initial, valuable_type) => {
  //   console.log(product_category, tag_initial, "Inidiidhdhh");
  //   try {
  //     const response = await axios.delete(
  //       "http://localhost:3333/api/deleteTag",
  //       {
  //         data: { product_category, tag_initial, valuable_type },
  //       }
  //     );
  //     toast.success(response.data.message, {
  //       autoClose: 6000,
  //     });
  //     window.location.reload();
  //     // console.log(response.data.message);
  //   } catch (error) {
  //     console.error("Error deleting tag data:", error);
  //     // Handle the error, e.g., display an error message to the user
  //   }
  // };
  const handleNumOfDigitsChange = (e) => {
    const value = e.target.value;
    if (!/^\d*$/.test(value)) {
      setNumError("Please enter a valid positive number.");
    } else {
      const intValue = parseInt(value, 10);
      if (intValue > 9) {
        setNumError("Please enter a single digit.");
      } else if (
        ["QR Bag", "E-Bag", "Dolphin Smart Bag"].includes(productCategory) &&
        intValue > 4
      ) {
        setNumError(
          "For the selected product category, digits cannot exceed 4."
        );
      } else {
        setNumError("");
        // console.log(typeof value, "valuee");
        setNumOfDigits(intValue);
      }
    }
    clearFormErrors("numOfDigits");
  };

  const handleDownloadExcel = (row) => {
    setLoading(true);
    generateAndDownloadExcel(row);
  };
  
  const fetchDatacsv = async (params) => {
    try {
      const response = await axios.get(`${BASE_URL}/api/fetch-data`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        params,
        responseType: "blob", // Ensure binary data handling
      });
      return response; // Return full response including headers
    } catch (error) {
      console.error("Error fetching data:", error);
      throw error;
    }
  };
  
  const generateAndDownloadExcel = async (rowData) => {
    try {
      let params = {
        company_name: rowData.company_name || null,
        create_date: rowData.create_date || null,
        product_category: rowData.product_category || null,
        tag_initial: rowData.tag_initial || null,
        valuable_type: rowData.valuable_type || null,
        count: rowData.count || null,
      };
  
      const response = await fetchDatacsv(params);

      if (!response || !response.data) {
        throw new Error("Invalid response from server");
      }
      const excelBlob = response.data; // Extract blob data
      const contentDisposition = response.headers["content-disposition"] || response.headers["Content-Disposition"]; // Ensure headers exist
      let fileName = "tag_data.csv"; // Default filename
      if (contentDisposition) {
        const match = contentDisposition.match(/filename="?([^"]+)"?/);
        if (match && match[1]) {
          fileName = match[1].trim(); // Ensure no extra spaces
        }
      }
  
      const blob = new Blob([excelBlob], { type: "text/csv" });
  
      // Create a download link for the Excel file
      const link = document.createElement("a");
      link.href = window.URL.createObjectURL(blob);
      link.download = fileName;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (error) {
      console.error("Error generating Excel file:", error);
      toast.error("Error downloading Excel", { autoClose: 6000 });
    } finally {
      setLoading(false);
    }
  };  

  const fetchData = async () => {
    try {
      const config = {
        method: "get",
        url: `${BASE_URL}/api/tagcounts`,
        headers: {
          Authorization: `Bearer ${token}`,
        },
        params: {
          tagInitial,
          productCategory,
          count,
          valuableType,
          numOfDigits,
          companyName,
          updatepossiblity,
        },
      };
      const response = await axios(config);
      // console.log(response.data, "API response");
      if (response.data) {
        const initials = response.data.map((item) => item.tag_initial);
        setExistingTagInitials(initials);
        console.log(response.data.create_date, "date");
        const preJuly2024 = response.data
          .filter((item) => new Date(item.create_date) < new Date("2024-07-01"))
          .map((item) => item.tag_initial);
        setPreJuly2024TagInitials(preJuly2024);
      }
      // Aggregate data
      const aggregatedData = response.data.reduce((acc, item) => {
        const productCategory = item.product_category || "";
        const companyName = item.company_name || "";
        const valuableType = item.valuable_type || "";
        const tagGenerationId = item.tag_generation_id || "";
        const key = `${item.tag_initial}-${productCategory}-${companyName}-${valuableType}-${tagGenerationId}`;

        if (!acc[key]) {
          acc[key] = { ...item, count: 0 };
        }

        acc[key].count += item.count;
        return acc;
      }, {});

      // console.log(aggregatedData);

      // Convert aggregated data object back to array
      const aggregatedArray = Object.values(aggregatedData);
      // console.log(aggregatedArray, "aggregatedArray");
      setTableData(aggregatedArray);
      setFilteredData(aggregatedArray);

      let totalPossibility = 0;
      response.data.forEach((item) => {
        if (item.possibility !== undefined) {
          const tagId = item.tag_generation_id;
          setupdatePossibility((prevState) => ({
            ...prevState,
            [tagId]: {
              possibility: item.possibility,
            },
          }));
        } else {
          console.error(
            `No 'possibility' property found for tag: ${item.tag_number}`
          );
        }
      });

      const uniqueCompanyNames = Array.from(
        new Set(response.data.map((item) => item.company_name))
      );
      setCompanies(uniqueCompanyNames);
      if (response.data.length > 0) {
        response.data.forEach((item) => {
          if (item.Num_of_digits !== undefined) {
            const tagId = item.tag_initial;
            setNumOfDigitsMap((prevState) => ({
              ...prevState,
              [tagId]: [...(prevState[tagId] || []), item.Num_of_digits],
            }));
          } else {
            console.error(
              `No 'possibility' property found for tag: ${item.tag_number}`
            );
          }
        });
      }
    } catch (error) {
      console.error("Error loading tag numbers:", error);
    }
  };

  useEffect(() => {
    fetchProductCategories();
    fetchData();
  }, []);

  const normalizeInsuranceAmount = (value) => {
    const normalizedValue = value === null || value === undefined || value === "" ? "3000" : String(value);
    return ["3000", "5000", "10000"].includes(normalizedValue) ? normalizedValue : "3000";
  };

  const hasExistingInsuranceAmount = (value) => {
    if (value === null || value === undefined || value === "" || value === 0 || value === "0") {
      return false;
    }
    return ["3000", "5000", "10000"].includes(String(value));
  };

  const setModalOpen = (isOpen, resetValues = true) => {
    if (resetValues) {
      setTagInitial("");
      setProductCategory("");
      setCount(0);
      setValuableType("");
      setNumOfDigits(4);
      setCompanyName("")
      setError("")
      setFormErrors({});
      setSchoolTagOption([]);
      setIsSchoolTag(false);
      // Reset insurance-related state on modal close/reset
      setInsuranceFlag(null);
      setInsuranceAmount("3000");
    }
    setEditingTag(null);
    setModalOpenState(isOpen);
  };

  const sortedData = [...tableData].sort((a, b) => {
    return new Date(b.create_date) - new Date(a.create_date);
  });
  const columns = [
    {
      dataField: "product_category",
      text: "Product Category",
      formatter: (cell) => cell || "N/A",
    },
    {
      dataField: "count",
      text: "Tag Count",
      formatter: (cell) => cell || "N/A",
    },
    {
      dataField: "tag_initial",
      text: "Tag Initial",
      formatter: (cell) => cell || "N/A",
    },
    {
      dataField: "create_date",
      text: "Create Date(DD/MM/YYYY)",
      formatter: (cell) => {
        if (!cell) return "N/A";
        const date = new Date(cell);
        if (isNaN(date.getTime())) return "Invalid Date";
        const day = String(date.getDate()).padStart(2, "0");
        const month = String(date.getMonth() + 1).padStart(2, "0"); // Month is 0-indexed
        const year = date.getFullYear();
    
        return `${day}/${month}/${year}`;
      },
    },
    {
      dataField: "valuable_type",
      text: "Valuable Type",
      formatter: (cell) => cell || "N/A",
    },
    {
      dataField: "company_name",
      text: "Company Name",
      formatter: (cell) => cell || "N/A",
    },
        {
      dataField: "insurance_value",
      text: "Insurance Amount",
      formatter: (cell) => {
        return cell !== undefined &&
          cell !== null &&
          cell !== ""
          ? cell
          : "N/A";
      },
    },
    {
      dataField: "possibility",
      text: "Tags Possibility",
      formatter: (cell) => cell || "N/A",
    },
      {
      dataField: "created_by",
      text: "Created By",
      formatter: (cell) => cell || "N/A",
    },
    {
      dataField: "modified_by",
      text: "Modified By",
      formatter: (cell) => cell || "N/A",
    },
    {
      dataField: "modified_date",
      text: "Modified Date(DD/MM/YYYY)",
      formatter: (cell, row) => {
        const dateValue = cell || row.create_date; // Use modified_date if available, otherwise use create_date
        if (!dateValue) return "N/A";
    
        const date = new Date(dateValue);
        // if (isNaN(date.getTime())) return "Invalid Date";
        
        const day = String(date.getDate()).padStart(2, "0");
        const month = String(date.getMonth() + 1).padStart(2, "0"); // Month is 0-indexed
        const year = date.getFullYear();
    
        return `${day}/${month}/${year}`;
      },
    },    
    {
      dataField: "action",
      text: "Action",
      formatter: (cellContent, user) => (
        <div className="d-flex gap-3 align-items-center">
          {/* Add icon (performs edit functionality) */}
          <span style={{ cursor: "pointer", color: "#28a745" }} title="Add" onClick={() => handleEdit(user)}>
            <i className="mdi mdi-plus font-size-18"></i>
          </span>
          {/* Pencil icon (opens insurance modal) for QR Bag and Dolphin Bag */}
          {isInsuranceProductCategory(user.product_category) && (
            <span
              style={{ cursor: "pointer", color: "#007bff" }}
              title="Edit Insurance"
              onClick={() => {
                setEditingTag(user);
                if (hasExistingInsuranceAmount(user.insurance_value)) {
                  setInsuranceValue(String(user.insurance_value));
                } else {
                  setInsuranceValue("3000");
                }
                setInsuranceStatus([]); // Always blank/unselected
                setInsuranceValueError("");
                setInsuranceStatusError("");
                setTimeout(() => openInsuranceModal(), 0);
              }}
            >
              <i className="mdi mdi-pencil font-size-18"></i>
            </span>
          )}
          {/* Excel download icon (unchanged) */}
          <span style={{ cursor: "pointer", color: "#28a745" }} title="Download Excel" onClick={() => handleDownloadExcel(user)}>
            <i className="mdi mdi-file-excel-outline font-size-18" />
          </span>
        </div>
      ),
    },

  ];

  const pageoptions = {
    sizePerPage: 10,
    totalSize: tableData.length,
  };
  // console.log(sortedData, "soretedddata");
  const filterdData = sortedData.filter((item) => {
    const productCategoryExists =
      item.product_category && typeof item.product_category === "string";
    const tagInitialExists =
      item.tag_initial && typeof item.tag_initial === "string";
    const valuableTypeExists =
      item.valuable_type && typeof item.valuable_type === "string";

    const searchKeyLower = searchKey.toLowerCase();

    return (
      (productCategoryExists &&
        item.product_category.toLowerCase().includes(searchKeyLower)) ||
      (tagInitialExists &&
        item.tag_initial.toLowerCase().includes(searchKeyLower)) ||
      (valuableTypeExists &&
        item.valuable_type.toLowerCase().includes(searchKeyLower))
    );
  });

  const getCurrentDate = () => {
    const today = new Date();
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, "0");
    const day = String(today.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  };

  const currentDate = getCurrentDate();
  const renderTable = () => {
    if (searchKey) {
      return (
        <BootstrapTable
          keyField="tag_code"
          className="my-custom-table"
          data={filterdData}
          columns={columns}
          pagination={paginationFactory(pageoptions)}
          responsive
        />
      );
    } else {
      return (
        <BootstrapTable
          keyField="tag_code"
          className="my-custom-table"
          data={sortedData}
          columns={columns}
          pagination={paginationFactory(pageoptions)}
          responsive
        />
      );
    }
  };
  // console.log(loading, "Loadinng");
  return (
    <>
      <div>
        {/* Insurance Modal */}
        <Modal isOpen={insuranceModalOpen} toggle={closeInsuranceModal}>
          <ModalHeader toggle={closeInsuranceModal}>Add Insurance</ModalHeader>
          <ModalBody>
            <form onSubmit={handleInsuranceSubmit}>
              <div className="mb-3">
                <Label>Type of Status</Label>
                <div className="d-flex gap-3">
                  <div className="form-check">
                    <Input
                      type="checkbox"
                      id="statusActive"
                      checked={insuranceStatus.includes("Active")}
                      onChange={() => handleInsuranceStatusChange("Active")}
                    />
                    <Label for="statusActive" className="form-check-label">Active</Label>
                  </div>
                  <div className="form-check">
                    <Input
                      type="checkbox"
                      id="statusInactive"
                      checked={insuranceStatus.includes("Inactive")}
                      onChange={() => handleInsuranceStatusChange("Inactive")}
                    />
                    <Label for="statusInactive" className="form-check-label">Inactive</Label>
                  </div>
                </div>
              </div>
              <div className="mb-3">
                <Label for="insuranceValue">Insurance Value</Label>
                <Input
                  id="insuranceValue"
                  type="select"
                  value={insuranceValue}
                  onChange={e => {
                    setInsuranceValue(e.target.value);
                    setInsuranceValueError("");
                  }}
                  required
                  invalid={!!insuranceValueError}
                  disabled={hasExistingInsuranceAmount(editingTag?.insurance_value)}
                >
                  <option value="3000">3000</option>
                  <option value="5000">5000</option>
                  <option value="10000">10000</option>
                </Input>
                {insuranceValueError && (
                  <div style={{ color: "red", marginTop: 4 }}>{insuranceValueError}</div>
                )}
              </div>
              {insuranceStatusError && (
                <div style={{ color: "red", marginBottom: 8 }}>{insuranceStatusError}</div>
              )}
              <Button color="primary" type="submit">Submit</Button>
            </form>
          </ModalBody>
        </Modal>
        <Card>
          {loading && (
            <div style={loaderContainerStyle}>
              <div className="loader">
                <img
                  src={
                    "https://storage.googleapis.com/pettag/qr/assets/loader.gif"
                  }
                  alt="Loading..."
                  loading="lazy"
                  style={loaderStyle}
                />
              </div>
            </div>
          )}
          <CardBody>
            <div style={{ marginTop: "7.5rem" }}>
              <div style={{ display: "flex", flexWrap: "wrap", gap: "10px" }}>
                <Button onClick={() => setModalOpen(true)}>
                  Open Tag Generation Form
                </Button>
                <Button onClick={() => setNewModalOpen(true)}>
                  Open Generator
                </Button>

              </div>
              <div
                style={{ float: "right", marginTop: "10px" }}
                className="search-box ms-2 mb-2 d-inline-block"
              >
                <div className="position-relative">
                  <div className="input-group">
                    <div className="form-outline">
                      <input
                        type="search"
                        id="form1"
                        placeholder="Search By Product Category"
                        className="form-control"
                        name="searchkey"
                        value={searchKey}
                        onChange={(event) => setSearchKey(event.target.value)}
                      />
                    </div>
                  </div>
                  <i className="bx bx-search-alt search-icon" />
                </div>
              </div>
              <Row style={{ width: "100%", marginTop: "20px" }}>
                <Col>
                  <div className="custom-table-container">{renderTable()}</div>
                </Col>
              </Row>
            </div>
          </CardBody>
        </Card>

        <Modal isOpen={modalOpen} toggle={() => setModalOpen(false)}>
          <ModalHeader toggle={() => setModalOpen(false)}>
            {editingTag ? "Update Tag Number" : "Generate Tag Number"}
          </ModalHeader>
          <ModalBody>
            <Container className="generation-container">
              <div className="form">
                <Label for="tagInitial">
                  Tag Initial
                  <span className="text-danger"> *</span>
                </Label>
                <Input
                  type="text"
                  id="tagInitial"
                  value={tagInitial}
                  onChange={handleTagInitialChange}
                  invalid={!!formErrors.tagInitial || !!errorMessageinital}
                  disabled={editingTag}
                />
                {(formErrors.tagInitial || errorMessageinital) && (
                  <p style={{ color: "red" }}>{formErrors.tagInitial || errorMessageinital}</p>
                )}
                <label
                  htmlFor="productCategory"
                  style={{ display: "block", marginBottom: "10px" }}
                >
                  Product Category
                  <span className="text-danger"> *</span>
                </label>
                <div
                  className="custom-dropdown"
                  style={{
                    display: "inline-block",
                    position: "relative",
                    marginBottom: "18px",
                  }}
                >
                  <select
                    id="productCategory"
                    value={productCategory}
                    onChange={(e) => {
                      setProductCategory(e.target.value);
                      clearFormErrors(
                        "productCategory",
                        "schoolTagOption",
                        "insuranceFlag",
                        "insuranceAmount"
                      );
                    }}
                    disabled={editingTag}
                  >
                   <option value="">Select a product category</option>
                    {productCategories.map((category, index) => (
                      <option key={index} value={category}>
                        {category}
                      </option>
                    ))} 
                  </select>
                </div>
                {formErrors.productCategory && (
                  <p style={{ color: "red" }}>{formErrors.productCategory}</p>
                )}

                <Label
                  for="numOfDigits"
                  style={{ display: "block", marginBottom: "10px" }}
                >
                  Number of Digits
                  <span className="text-danger"> *</span>
                </Label>
                <Input
                  type="number"
                  id="numOfDigits"
                  value={numOfDigits}
                  onChange={handleNumOfDigitsChange}
                  invalid={!!formErrors.numOfDigits || !!numError}
                  disabled={isNumOfDigitsDisabled}
                />
                {(formErrors.numOfDigits || numError) && (
                  <div style={{ color: "red", marginTop: "5px" }}>
                    {formErrors.numOfDigits || numError}
                  </div>
                )}
                <Label for="valuableType">
                  Comments
                  <span className="text-danger"> *</span>
                </Label>
                <small className="form-text text-muted d-block mb-2">
                  Mention your valuable items here (e.g., Laptop, Mobile, Watch, Jewellery, etc.).
                </small>
                <Input
                  type="text"
                  id="valuableType"
                  value={valuableType}
                  onChange={(e) => {
                    setValuableType(e.target.value);
                    clearFormErrors("valuableType");
                  }}
                  invalid={!!formErrors.valuableType}
                  disabled={editingTag}
                />
                {formErrors.valuableType && (
                  <p style={{ color: "red" }}>{formErrors.valuableType}</p>
                )}

                <label htmlFor="companyName">
                  Company Name
                  <span className="text-danger"> *</span>
                </label>
                <div className="d-flex">
                  <Input
                    type="text"
                    id="companyName"
                    value={companyName}
                    onChange={(e) => {
                      setCompanyName(e.target.value);
                      clearFormErrors("companyName");
                    }}
                    invalid={!!formErrors.companyName}
                    disabled={editingTag}
                  />
                  <Dropdown
                    isOpen={dropdownOpen}
                    toggle={toggleDropdown}
                    disabled={editingTag}
                  >
                    <DropdownToggle onClick={addCompany} caret>
                      <FaPlus size={20} />
                    </DropdownToggle>
                    <DropdownMenu>
                      {companies.map((company, index) => (
                        <DropdownItem
                          key={index}
                          onClick={() => selectCompany(company)}
                          disabled={editingTag}
                        >
                          {company}
                        </DropdownItem>
                      ))}
                    </DropdownMenu>
                  </Dropdown>
                </div>
                {formErrors.companyName && (
                  <p style={{ color: "red" }}>{formErrors.companyName}</p>
                )}
                {productCategory === "QR Human" && (
                  <div className="mt-3 mb-3">
                    <Label for="schoolTagOption" className="d-block mb-2 fw-bold">
                      More Features
                      <span className="text-danger"> *</span>
                    </Label>
                    <Select
                      inputId="schoolTagOption"
                      isMulti
                      closeMenuOnSelect={false}
                      hideSelectedOptions={false}
                      isClearable={!editingTag}
                      isDisabled={!!editingTag}
                      options={MORE_FEATURE_OPTIONS}
                      placeholder="Select More Features"
                      value={MORE_FEATURE_OPTIONS.filter((option) =>
                        schoolTagOption.includes(option.value)
                      )}
                      onChange={(selected) => {
                        if (editingTag) {
                          return;
                        }
                        updateSchoolTagSelection(selected);
                        clearFormErrors("schoolTagOption");
                      }}
                    />
                    {formErrors.schoolTagOption && (
                      <p style={{ color: "red" }}>{formErrors.schoolTagOption}</p>
                    )}
                  </div>
                )}
                <Label for="count">
                  Count
                  <span className="text-danger"> *</span>
                </Label>
                <Input
                  type="number" 
                  id="count"
                  value={count}
                  onChange={handleCountChange}
                  invalid={!!formErrors.count || !!error}
                />
                {(formErrors.count || error) && (
                  <p style={{ color: "red" }}>{formErrors.count || error}</p>
                )}

                {/* Insurance applied? field (Finder Options style, always editable) */}
                {isInsuranceProductCategory(productCategory) && (
                  <div style={{ margin: '16px 0' }}>
                    <Label style={{ fontWeight: 'bold', marginBottom: 8 }}>
                      Insurance applied?
                      <span className="text-danger"> *</span>
                    </Label>
                    <div>
                      <Input
                        type="radio"
                        id="insuranceNo"
                        name="insuranceFlag"
                        value="no"
                        checked={insuranceFlag === false}
                        onChange={() => {
                          setInsuranceFlag(false);
                          setInsuranceAmount("3000");
                          clearFormErrors("insuranceFlag", "insuranceAmount");
                        }}
                      />
                      <Label for="insuranceNo" style={{ marginRight: 16, marginLeft: 4 }}>No</Label>
                      <Input
                        type="radio"
                        id="insuranceYes"
                        name="insuranceFlag"
                        value="yes"
                        checked={insuranceFlag === true}
                        onChange={() => {
                          setInsuranceFlag(true);
                          if (hasExistingInsuranceAmount(editingTag?.insurance_value)) {
                            setInsuranceAmount(normalizeInsuranceAmount(editingTag.insurance_value));
                          } else {
                            setInsuranceAmount("3000");
                          }
                          clearFormErrors("insuranceFlag");
                        }}
                      />
                      <Label for="insuranceYes" style={{ marginLeft: 4 }}>Yes</Label>
                    </div>
                    {formErrors.insuranceFlag && (
                      <p style={{ color: "red" }}>{formErrors.insuranceFlag}</p>
                    )}
                    {/* Insurance Amount field: always rendered, only visible if Yes */}
                    <div
                      style={{
                        marginTop: 12,
                        display: insuranceFlag === true ? 'block' : 'none',
                        transition: 'all 0.2s',
                      }}
                    >
                      <Label for="insuranceAmount">
                        Insurance Amount
                        <span className="text-danger"> *</span>
                      </Label>
                      <Input
                        type="select"
                        id="insuranceAmount"
                        value={insuranceAmount}
                        onChange={e => {
                          setInsuranceAmount(e.target.value);
                          clearFormErrors("insuranceAmount");
                        }}
                        invalid={!!formErrors.insuranceAmount}
                        disabled={
                          insuranceFlag !== true ||
                          hasExistingInsuranceAmount(editingTag?.insurance_value)
                        }
                      >
                        <option value="3000">3000</option>
                        <option value="5000">5000</option>
                        <option value="10000">10000</option>
                      </Input>
                      {formErrors.insuranceAmount && (
                        <p style={{ color: "red" }}>{formErrors.insuranceAmount}</p>
                      )}
                    </div>
                  </div>
                )}
                <div className="finder-options">
                  <Label
                    style={{
                      display: "block",
                      marginBottom: "10px",
                      fontWeight: "bold",
                    }}
                  >
                    Finder Options
                    <span className="text-danger"> *</span>
                  </Label>
                  <div>
                    <Input
                      type="checkbox"
                      id="finderUserOption"
                      name="finderOptions"
                      checked={options.user}
                      onChange={() => {
                        handleOptionChange("user");
                        clearFormErrors("finderOptions");
                      }}
                      disabled={editingTag}
                    />
                    <Label for="finderUserOption" className="ml-2">
                      User
                    </Label>
                  </div>
                  <div>
                    <Input
                      type="checkbox"
                      id="tag8SupportOption"
                      name="finderOptions"
                      checked={options.tag8Support}
                      onChange={() => {
                        handleOptionChange("tag8Support");
                        clearFormErrors("finderOptions");
                      }}
                      disabled={editingTag}
                    />
                    <Label for="tag8SupportOption" className="ml-2">
                      Tag8 Support
                    </Label>
                  </div>
                  {formErrors.finderOptions && (
                    <p style={{ color: "red" }}>{formErrors.finderOptions}</p>
                  )}
                </div>
                <div>
                  <Label
                    for="validityFrom"
                    style={{
                      display: "block",
                      marginBottom: "10px",
                      fontWeight: "bold",
                    }}
                  >
                    Validity Duration
                  </Label>
                  <small className="form-text text-muted d-block mb-3">
                    The duration for which the tag remains valid after activation.
                  </small>
                  <Label
                    for="validityNumber"
                    style={{ display: "block", marginBottom: "10px" }}
                  >
                    Validity Number
                    <span className="text-danger"> *</span>
                  </Label>
                  <Input
                    type="number"
                    id="validityNumber"
                    min={0}
                    value={validityNumber}
                    onChange={(e) => {
                      const value = e.target.value;
                      if (value !== "" && (value.startsWith("-") || Number(value) < 0)) {
                        return;
                      }
                      setValidityNumber(value);
                      clearFormErrors("validityNumber");
                    }}
                    invalid={!!formErrors.validityNumber}
                    disabled={editingTag}
                  />
                  {formErrors.validityNumber && (
                    <p style={{ color: "red" }}>{formErrors.validityNumber}</p>
                  )}

                  <Label
                    for="validityUnit"
                    style={{ display: "block", marginBottom: "10px" }}
                  >
                    Validity Unit
                    <span className="text-danger"> *</span>
                  </Label>
                  <Input
                    type="select"
                    id="validityUnit"
                    value={validityUnit}
                    onChange={(e) => {
                      setValidityUnit(e.target.value);
                      clearFormErrors("validityUnit");
                    }}
                    invalid={!!formErrors.validityUnit}
                    disabled={editingTag}
                  >
                    <option value="">Select Validity Unit</option>
                    <option value="Days">Days</option>
                    <option value="Months">Months</option>
                    <option value="Year">Year</option>
                  </Input>
                  {formErrors.validityUnit && (
                    <p style={{ color: "red" }}>{formErrors.validityUnit}</p>
                  )}
                </div>

                <Label
                  for="validityToDate"
                  style={{
                    display: "block",
                    marginBottom: "10px",
                    fontWeight: "bold",
                  }}
                >
                  Activation Validity
                  <span className="text-danger"> *</span>
                </Label>
                <small className="form-text text-muted d-block mb-2">
                  The date and time until which the tag can be activated.
                </small>
                <Input
                  type="date"
                  id="validityToDate"
                  value={validityToDate}
                  onChange={(e) => {
                    setValidityToDate(e.target.value);
                    clearFormErrors("validityToDate");
                  }}
                  min={currentDate}
                  invalid={!!formErrors.validityToDate}
                />
                {formErrors.validityToDate && (
                  <p style={{ color: "red" }}>{formErrors.validityToDate}</p>
                )}
                <Button
                  color="primary"
                  onClick={handleGenerateTagNumber}
                  className="button"
                  disabled={error || (editingTag && preJuly2024TagInitials.includes(tagInitial))}
                >
                  {editingTag ? "Update" : "Generate"}
                </Button>
                {!editingTag ? (
                  <>
                    {possiblity && (
                      <p style={{ color: "green" }}>
                        `{possiblity} number of combinations can be generated
                        for this initial `
                      </p>
                    )}
                  </>
                ) : (
                  ""
                )}
                {editingTag && (
                  <>
                    {Object.entries(updatepossiblity).map(
                      ([tagId, { possibility }]) =>
                        tagId === tagGeneration && (
                          <p
                            key={tagId}
                            style={{
                              color:
                                tagId === tagGeneration ? "green" : "black",
                            }}
                          >
                            {`${possibility} number of combinations can be generated for tag.`}
                          </p>
                        )
                    )}
                  </>
                )}
              </div>
              <ToastContainer />
            </Container>
          </ModalBody>
        </Modal>
        {/* New Modal */}
        <Modal
          isOpen={newModalOpen}
          toggle={() => setNewModalOpen(!newModalOpen)}
        >
          <ModalHeader toggle={() => setNewModalOpen(!newModalOpen)}>
            New Tag Generation
          </ModalHeader>
          <ModalBody>
            <Container className="generation-container">
              <div className="form">
                <Label for="newNumOfDigits">Number of Digits</Label>
                <Input
                  type="number"
                  id="newNumOfDigits"
                  value={numOfDigits}
                  onChange={handleNumOfDigitsChange}
                />

                <Label for="newCount">Count</Label>
                <Input
                  type="number"
                  id="newCount"
                  value={count}
                  onChange={(e) => setCount(e.target.value)}
                />

                <Button
                  color="primary"
                  onClick={handleNewTagGeneration}
                  className="button"
                >
                  Generate
                </Button>
              </div>
              <ToastContainer />
            </Container>
          </ModalBody>
        </Modal>
      </div>
    </>
  );
}

export default TagGeneration;
